import { Navigate, Route, Routes } from "react-router";

import { ExplorerPage } from "./pages/ExplorerPage";
import { LoginView } from "./pages/LoginView";

export function App() {
  return (
    <Routes>
      <Route path="/app" element={<ExplorerPage />} />
      <Route path="/login" element={<LoginView />} />
      <Route path="*" element={<Navigate to="/app" replace />} />
    </Routes>
  );
}
